import { defineComponent, computed, createBlock, createCommentVNode, openBlock, resolveDynamicComponent } from "vue";
import { getIcon } from "../icons/index.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FlowIcon",
  props: {
    icon: {}
  },
  setup(__props) {
    const props = __props;
    const data = computed(() => getIcon(props.icon));
    return (_ctx, _cache) => {
      return data.value ? (openBlock(), createBlock(resolveDynamicComponent(data.value), {
        key: 0,
        class: "flow-icon",
        height: "100%"
      })) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FlowIcon.vue.js.map
